import { useMount } from './useMount.js';
import { useRef } from 'react';
// TODO rename to useUnmountEffect
export const useUnmount = (effect) => {
    const effectRef = useRef(effect);
    // update the ref each render so if it change the newest callback will be invoked
    effectRef.current = effect;
    useMount(() => {
        return () => {
            effectRef.current();
        };
    });
};
//# sourceMappingURL=useUnmount.js.map